export const ON_NEW_CHANNEL = `
  subscription OnNewChannel {
    onNewChannel {
      _id
      name
      type
      members
      description
      senderAvatar
      extraData
      referenceNo
      priority
      priorityNote
      customer {
        name
        company
        email
        clientId
      }
      status
      isExternal
      lastSenderId
      firstCustomerMessageAt
      firstAgentResponseAt
      lastCustomerMessageAt
      totalResponseTimeSeconds
      responseCount
      applicationStatus
      createdAt
      updatedAt
    }
  }
`;

export const ON_UPDATE_CHANNEL = `
  subscription OnUpdateChannel {
    onUpdateChannel {
      _id
      name
      type
      members
      description
      senderAvatar
      extraData
      referenceNo
      priority
      priorityNote
      customer {
        name
        company
        email
        clientId
      }
      status
      isExternal
      lastSenderId
      firstCustomerMessageAt
      firstAgentResponseAt
      lastCustomerMessageAt
      totalResponseTimeSeconds
      responseCount
      applicationStatus
      createdAt
      updatedAt
    }
  }
`;

export const ON_NEW_MESSAGE = /* GraphQL */ `
    subscription OnNewMessage {
        onNewMessage {
            _id
            channelId
            content
            createdAt
            files
            isFromBot
            sender {
                _id
                firstName
                lastName
                avatar
            }
            senderId
            updatedAt
        }
    }
`;

export const GET_MESSAGES = `
  query GetMessages($channelId: ID!, $page: Int) {
    getMessages(channelId: $channelId, page: $page) {
      _id
      channelId
      content
      createdAt
      files
      isFromBot
      senderId
      sender {
          _id
          firstName
          lastName
          avatar
        }
      updatedAt
    }
  }
`;

export const GET_FILES = `
  query GetFiles($channelId: ID!) {
    getFiles(channelId: $channelId) {
      _id
      content
      createdAt
      files
      senderId
    }
  }
`;

// memberIds must stay selected; see SEND_MESSAGE in ../graphql/mutations.ts.
export const SEND_MESSAGE = `
  mutation SendMessage($channelId: ID!, $content: String!, $files: [String]) {
  sendMessage(
    channelId: $channelId,
    content: $content,
    files: $files
  ) {
    _id
    channelId
    content
    files
    senderId
    sender {
          _id
          firstName
          lastName
          avatar
        }
    isFromBot
    createdAt
    updatedAt
    memberIds
  }
}
`;

export const UPDATE_CHANNEL = `
  mutation UpdateChannel($channelId: ID!, $name: String, $status: String, $priority: String, $lastSenderId: String, $firstCustomerMessageAt: AWSDateTime, $firstAgentResponseAt: AWSDateTime, $lastCustomerMessageAt: String, $totalResponseTimeSeconds: Int, $responseCount: Int, $applicationStatus: String) {
  updateChannel(
    channelId: $channelId
    name: $name
    status: $status
    priority: $priority
    lastSenderId: $lastSenderId
    firstCustomerMessageAt: $firstCustomerMessageAt
    firstAgentResponseAt: $firstAgentResponseAt
    lastCustomerMessageAt: $lastCustomerMessageAt
    totalResponseTimeSeconds: $totalResponseTimeSeconds
    responseCount: $responseCount
    applicationStatus: $applicationStatus
  ) {
      _id
      name
      description
      senderAvatar
      type
      members
      customer {
        name
        company
        email
        clientId
      }
      status
      priority
      priorityNote
      lastSenderId
      firstCustomerMessageAt
      firstAgentResponseAt
      lastCustomerMessageAt
      totalResponseTimeSeconds
      responseCount
      applicationStatus
      isExternal
      createdAt
      updatedAt
  }
}
`;

export const JOIN_CHANNEL = `
  mutation JoinChannel($channelId: ID!) {
  joinChannel(
    channelId: $channelId
  ) {
      _id
      name
      type
      members
      senderAvatar
      description
      messages {
        _id
        channelId
        content
        files
        senderId
        isFromBot
        sender {
          _id
          firstName
          lastName
          avatar
        }
        createdAt
        updatedAt
      }
      customer {
        name
        company
        email
        clientId
      }
      status
      isExternal
      createdAt
      updatedAt
  }
}
`;

export const MARK_CHANNEL_AS_READ = /* GraphQL */ `
    mutation MarkChannelAsRead($channelId: ID!, $userId: ID!, $lastReadMessageId: String!) {
        markChannelAsRead(
            channelId: $channelId
            userId: $userId
            lastReadMessageId: $lastReadMessageId
        ) {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;

export const DECREMENT_UNREAD_COUNT = /* GraphQL */ `
    mutation DecrementUnreadCount($channelId: ID!, $userId: ID!, $decrement: Int) {
        decrementUnreadCount(channelId: $channelId, userId: $userId, decrement: $decrement) {
            channelId
            userId
            unreadCount
            updatedAt
        }
    }
`;

export const INCREMENT_UNREAD_COUNT = /* GraphQL */ `
    mutation IncrementUnreadCount($channelId: ID!, $userId: ID!, $increment: Int) {
        incrementUnreadCount(channelId: $channelId, userId: $userId, increment: $increment) {
            channelId
            userId
            unreadCount
            updatedAt
        }
    }
`;

export const RESET_UNREAD_COUNT = /* GraphQL */ `
    mutation ResetUnreadCount($channelId: ID!, $userId: ID!) {
        resetUnreadCount(channelId: $channelId, userId: $userId) {
            channelId
            userId
            unreadCount
            updatedAt
        }
    }
`;

export const GET_USER_CHANNEL_READS = /* GraphQL */ `
    query GetUserChannelReads($userId: ID!, $limit: Int, $nextToken: String) {
        getChannelReadsByUserId(userId: $userId, limit: $limit, nextToken: $nextToken) {
            items {
                channelId
                userId
                lastReadMessageId
                unreadCount
                updatedAt
            }
            nextToken
        }
    }
`;

export const GET_CHANNEL_READ_BY_CHANNEL_AND_USER = /* GraphQL */ `
    query GetChannelReadByChannelAndUser($channelId: ID!, $userId: ID!) {
        getChannelReadByChannelAndUser(channelId: $channelId, userId: $userId) {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;

export const ON_CHANNEL_READ = /* GraphQL */ `
    subscription OnChannelRead {
        onChannelRead {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;

export const ON_UNREAD_COUNT_CHANGE = /* GraphQL */ `
    subscription OnUnreadCountChange {
        onUnreadCountChange {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;
